import { render } from "./Games.vue?vue&type=template&id=40dd1c6e&scoped=true&ts=true"
import script from "./Games.vue?vue&type=script&lang=ts"
export * from "./Games.vue?vue&type=script&lang=ts"

import "./Games.vue?vue&type=style&index=0&id=40dd1c6e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dd1c6e"]])

export default __exports__